import React from 'react';
import { SvgIcon } from './SvgIcon';

export const createSvgIcon = (icon) => {
  return React.forwardRef((props, ref) => {
    return <SvgIcon component={icon} {...props} ref={ref} />;
  });
};
